<template>
	<div class='photo'>
		
		<div class='photo__header'>
			<div class='photo__title'>Фотоматериалы</div>
<!-- 			<div class='photo__button-block'>
				<p-button label='Выбрать все' @click='selectPhotoAll' class='p-button-sm p-mr-2'/>
				<p-button label='Удалить выбранные' @click='removeSelectedPhoto' class='p-button-sm'/>
			</div> -->
		</div>

		<div class='photo__content'>
			<div v-for='image in photoList' class='photo__image-container'>
				<img :src='image.url' class='photo__image'>
				<custom-p-checkbox v-model='image.checked' class='photo__checkbox' :disabled='!actLpoIsDraft'/>
				<div v-if='!isDimensionCorrect(image)' v-tooltip='""' class='photo__warning-icon-block'>
					<i class='fa fa-exclamation-circle'></i>
				</div>
			</div>
		</div>

		<p-message v-if='!allDimensionsAreCorrect' severity='warn' :closable='false'>
			<div>
				У некоторых загруженных изображений некорректное разрешение
			</div>
			<div>
				<div>Ширина и высота картинок должна быть равна (или больше):
				<div>
					3072 х 2304,
					2034 х 3072,
					3552 х 2000,
					2000 х 3552
				</div>
				</div>
			</div>
		</p-message>

		<div class='photo__button-block'>
			<p-button label='Выбрать все' icon='fa fa-tasks' @click='selectPhotoAll' class='p-button-sm p-mr-2' :disabled='!actLpoIsDraft'/>
			<p-button label='Удалить выбранные' icon='fa fa-trash' :disabled='!selectedPhotoList.length || !actLpoIsDraft' @click='removeSelectedPhoto' class='p-button-sm p-button-danger'/>
		</div>

	</div>
</template>

<script>
	const ROOT_API = process.env.VUE_APP_ROOT_API;
	const PHOTO_REMOVE_IMAGES = ROOT_API + 'load_file/photo_remove_images.php';

	const NAP_REF = `П. 57 Правил осуществления мероприятий по предупреждению распространения вредных организмов, утвержденных Приказом Минприроды России от 09.11.2020 № 912. 
Уборка неликвидной древесины проводится в местах образования ветровала, бурелома, снеголома, верховых пожаров и других повреждений при наличии неликвидной и дровяной древесины более 90% от общего запаса погибших и поврежденных деревьев, а также в случаях, когда заготовка древесины погибших или поврежденных насаждений запрещена.
В первую очередь уборка неликвидной древесины производится в лесах, выполняющих функции защиты природных и иных объектов, а также в ценных лесах. На землях другого целевого назначения и иных категорий защитных лесов уборка неликвидной древесины производится в случае, если создается угроза пожарной опасности в лесах и возникновения очагов вредных организмов.`

	export default {
		name: 'ActUploadPhoto',

		props: {
			currentLpo: Object,
			photoList: Array
		},

		

		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			selectedPhotoList() {
				return this.photoList.filter(photo => photo.checked);
			},

			allDimensionsAreCorrect() {
				let result = true;

				const finded = this.photoList.find(photo => !this.isDimensionCorrect(photo));

				return finded ? false : true;
			},
		},

		methods: {
			selectPhotoAll() {
				if (!this.photoList.find(item => item.checked === false)) {
					for (let item of this.photoList) {
						item.checked = false;
					}
				} else {
					for (let item of this.photoList) {
						item.checked = true;
					}
				}
			},

			isDimensionCorrect(image) {

				/*
					correct dimensions: 
					3552 x 2000
					3072 x 2304
					2034 x 3072
					2000 x 3552
				*/	

				if (image.width >= 3552) {
					return (image.height >= 2000) ? true : false;
				}

				if (image.width >= 3072) {
					return (image.height >= 2304) ? true : false;
				}

				if (image.width >= 2034) {
					return (image.height >= 3072) ? true : false;
				}

				if (image.width >= 2000) {
					return (image.height >= 3552) ? true : false;
				}

				return false;
			},

			removeSelectedPhoto() {
				if (!this.selectedPhotoList.length) {
					return;
				}

				const form = new FormData();
				form.append('lpo_id', this.currentLpo.lpo_id);
				form.append('image_list', JSON.stringify(this.selectedPhotoList));

				fetch(PHOTO_REMOVE_IMAGES, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then( res => this.$emit('removed'));
			}
		}
	};
</script>

<style scoped>
	.photo__header {
		/*border-bottom: 1px solid black;*/
		/*padding-bottom: 0.5rem;*/

		/*color:;*/

		margin-bottom: 1rem;

		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 1rem;
		margin-top: 1rem;

		font-size: 1rem;
		font-weight: bold;
		color: #6c757d;
	}

	.photo__content {
		display: flex;
		/*justify-content: center;*/
		flex-wrap: wrap;
		gap: 1rem;
		margin-bottom: 1rem;
	}

	.photo__image-container {
		border: 1px solid #cacaf2;
		border-radius: 2px;
		cursor: pointer;
		position: relative;
		height: 100px;
		width: 100px;
		min-width: 100px;
		overflow: hidden;
		transition: all 0.12s ease;
	}

	.photo__image-container:hover {
		border: 3px solid #2196F3;
	}

	.photo__image {
		width: 100%;
	}

	.photo__checkbox {
		position: absolute;
		top: 0.2rem;
		right: 0.2rem;
		z-index:100;
	}

	.photo__warning-icon-block {
		color: red;
		font-size: 1.5rem;
		position: absolute;
		bottom: 0.2rem;
		right: 0.2rem;
		z-index:100;
	}

	.photo__button-block {

	}
</style>